import template from "./entity-business-profile.html";
import "./entity-business-profile.less";

import {
	FORM_ENTITY_BUSINESSES, 
	FORM_BUSINESS 
} from "routes";

import {
	ENTITY_TRANSLATION_KEYS, 
	I18NextContext 
} from "../../../../../../../services/i18nService";
import { globs } from "../../../../../../../services/globs";

export function controller($logger, api, appState, loadingService, $uibModal, toastr, $scope, entityBusinessService) {
	const ctrl = this;

	ctrl.i18n = I18NextContext.Instance;
	ctrl.ENTITY_TRANSLATION_KEYS = ENTITY_TRANSLATION_KEYS;

	ctrl.$onInit = () => {
		ctrl.canUpdateBusinessGlob = globs.business.byType("*").update;

		$scope.$watch(() => ctrl.businessProfile?.Id, () => {
			loadBusiness();
		});
	};

	ctrl.editBusiness = async() => {
		if(ctrl.businessProfile === undefined) {
			ctrl.business = {
				Name: ctrl.entity.Name
			};
		}

		ctrl.businessProfile = await $uibModal.open({
			component: "entity-business-modal",
			size: "smmd",
			backdrop: "static",
			resolve: {
				business: () => ctrl.businessProfile ?? ctrl.business,
				save: () => saveBusiness
			}
		}).result;
	};

	async function saveBusiness(business) {
		let saveBusiness;
		if(business.Id === undefined) {
			saveBusiness = ctrl.post(FORM_ENTITY_BUSINESSES(appState.forms.selected.Id, ctrl.entity.Id), business);
		}
		else {
			saveBusiness = ctrl.put(FORM_BUSINESS(appState.forms.selected.Id, business.Id), business);
		}
		const resp = await loadingService.watch(saveBusiness);
		entityBusinessService.invalidateBusinessesForEntity(appState.forms.selected.Id, ctrl.entity.Id);

		toastr.success("Business saved successfully");

		return resp;
	}

	async function loadBusiness() {
		const business = await loadingService.watch(api.get(FORM_BUSINESS(appState.forms.selected.Id, ctrl.businessProfile.Id)));
		
		ctrl.businessProfile = business;
	}
}

export default angular.module("vesl.components.entity-business-profile", [])
	.component("entityBusinessProfile", {
		controller,
		template,
		bindings: {
			businessProfile: "=",
			entity: "<",
			put: "=",
			post: "="
		}
	})
	.name;
